<template>
  <span v-if="!decisionMade" />
  <Test v-else-if="showNonControlExperience" />
  <Control v-else />
</template>

<script>
import Control from '../../views/IdentityCheck/mobile.vue';
import Test from '../../views/IdentityCheck/new-flow-test.vue';
import { track } from '../../analytics/events';

export default {
  name: 'ThirdAddressModal',
  testExperienceName: 'Mobile Third Address Modal - No Modal',
  testPlacement: 'IdentityCheck',
  components: {
    Control,
    Test,
  },
  data() {
    return {
      decisionMade: false,
      showNonControlExperience: false,
    };
  },
  computed: {
    flagAmpersendEnabled() {
      return this.$store.get('flagAmpersendEnabled');
    },
  },
  async mounted() {
    const splits = this.flagAmpersendEnabled ? await this.$amp.getUnimpressedExperiences() : [];

    if (splits?.length) {
      const { agentId, name } = splits.find(this.findTestExperience) || {};

      this.showNonControlExperience = name === this.$options.testExperienceName;
      if (agentId) {
        track('DecisionMade', {
          agentId,
          name,
        });
      }
    }

    this.decisionMade = true;
  },
  methods: {
    findTestExperience({ templates: [template] }) {
      return template.properties.name === this.$options.testPlacement;
    },
  },
};
</script>
